/*
 * @copyright Copyright (c) valantic CEC Deutschland GmbH (https://www.valantic.com)
 * @see PROJECT_LICENSE.txt
 */

const Facet = /* GraphQL */ `
    fragment Facet on Aggregation {
        title
        attribute
        buckets {
            title
            __typename
            ... on CategoryView {
                name
                count
                path
            }
            ... on ScalarBucket {
                count
            }
            ... on RangeBucket {
                from
                to
                count
            }
            ... on StatsBucket {
                min
                max
            }
        }
    }
`;

const ProductView = /* GraphQL */ `
    fragment ProductView on ProductSearchItem {
        productView {
            __typename
            sku
            name
            inStock
            url
            urlKey
            images {
                label
                url
                roles
            }
            ... on SimpleProductView {
                __typename
                attributes {
                    label
                    name
                    roles
                    value
                }
            }
            ... on ComplexProductView {
                __typename
                attributes {
                    label
                    name
                    roles
                    value
                }
            }
        }
        highlights {
            attribute
            value
            matched_words
        }
    }
`;

const Product = /* GraphQL */ `
    fragment Product on ProductSearchItem {
        product {
            __typename
            sku
            id
            name
            canonical_url
            price_range {
                minimum_price {
                    fixed_product_taxes {
                        amount {
                            value
                            currency
                        }
                        label
                    }
                    regular_price {
                        value
                        currency
                    }
                    final_price {
                        value
                        currency
                    }
                    discount {
                        percent_off
                        amount_off
                    }
                }
                maximum_price {
                    fixed_product_taxes {
                        amount {
                            value
                            currency
                        }
                        label
                    }
                    regular_price {
                        value
                        currency
                    }
                    final_price {
                        value
                        currency
                    }
                    discount {
                        percent_off
                        amount_off
                    }
                }
            }
        }
    }
`;

export { Facet, Product, ProductView };
